import React, { useState } from "react";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import "./index.scss";

const DnD = ({ setFormDataState }) => {
  const [fileList, setFileList] = useState([]);

  const allowedExtensions = [".xls", ".xlsx", ".txt", ".csv", ".xml"];

  const beforeUpload = (file) => {
    const fileName = file.name.toLowerCase();
    const isAllowed = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!isAllowed) {
      message.error(`${file.name} is not allowed. Only .xls, .xlsx, .csv, and .txt files are accepted.`);
      return Upload.LIST_IGNORE;
    }

    const isSizeValid = file.size / 1024 / 1024 < 100;
    if (!isSizeValid) {
      message.error(`${file.name} exceeds 100MB size limit.`);
      return Upload.LIST_IGNORE;
    }

    // ✅ Manually control file list & pass to parent
    // const newFileList = [file];
    // setFileList(newFileList);
    // setFormDataState(file);

    // Allow adding more files to the list
    const updatedFileList = [...fileList, file];
    setFileList(updatedFileList);
    setFormDataState(updatedFileList); // pass all files up
    return false;
  };

  const onRemove = (file) => {
    // setFileList([]);
    // setFormDataState(null);
    const newList = fileList.filter(f => f.uid !== file.uid);
    setFileList(newList);
    setFormDataState(newList); // update parent
  };

  return (
    <Upload.Dragger
      name="file"
      fileList={fileList}
      beforeUpload={beforeUpload}
      onRemove={onRemove}
      accept=".xls,.xlsx,.txt,.csv,.xml,.zip" // ✅ browser level restriction too
      multiple={true}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag a file to this area to upload</p>
      <p className="ant-upload-hint">
        Only Excel (.xls, .xlsx, .csv, .xml, .zip) and text (.txt) files are allowed. One file at a time.
      </p>
    </Upload.Dragger>
  );
};

export default DnD;